const state = {
  list: []
};

const getters = {
  list(state, rootState) {
    return state.list;
  }
};

const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_ITEM(state, item) {
    const index = state.list.findIndex((x) => x.id === item.id);
    if (index >= 0) {
      this._vm.$set(state.list, index, item);
    } else {
      state.list.push(item);
    }
  },
  REMOVE(state, id) {
    const index = state.list.findIndex((x) => x.id === id);
    if (index >= 0) {
      state.list.splice(index, 1);
    }
  }
};

const actions = {
  getAll({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .get('customerProjects/get')
        .then((response) => {
          commit('SET_LIST', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  ignore({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .post(`customerProjects/ignore?id=${id}`)
        .then(() => {
          commit('REMOVE', id);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  claim({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .post(`customerProjects/claim?id=${id}`)
        .then((response) => {
          commit('SET_ITEM', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  copyProject({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .post(`customerProjects/copyProject?id=${req.id}&projectId=${req.projectId}`)
        .then((response) => {
          commit('SET_ITEM', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  finish({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .post(`customerProjects/finish?id=${id}`)
        .then((response) => {
          commit('SET_ITEM', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  approve({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$api
        .post(`customerProjects/approve?id=${id}`)
        .then((response) => {
          commit('SET_ITEM', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
